import { render, staticRenderFns } from "./StudioEventActionComponent.vue?vue&type=template&id=37a9e1bb&scoped=true&"
import script from "./StudioEventActionComponent.vue?vue&type=script&lang=js&"
export * from "./StudioEventActionComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudioEventActionComponent.vue?vue&type=style&index=0&id=37a9e1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9e1bb",
  null
  
)

export default component.exports